import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import axios from 'axios';
import './dashboard.css'
import moment from "moment";
import { getDatasAccService, patchAccDataService, patchMemberAccDataService, patchProspectAccDataService } from "../../API/accountApi";

async function getDatas() {
  let payload = {
    "id": "63e4885803f7970f472cfc94",
    search: [
      {
        searchfield: "_id",
        searchvalue: localStorage.getItem("LoginUserId"),
        criteria: "eq",
        datatype: "ObjectId",
      },
      {
        searchfield: "status",
        searchvalue: "active",
        criteria: "eq",
        datatype: "text"
      }
    ]
  };

  return getDatasAccService(payload);
}

export default function MyAccount() {
  const [isLoading, setLoader] = useState(true);
  const [account, setAccount] = useState(null);
  const [profilepic, setProfilepic] = useState(null);
  const [uploadImgLoader, showUploadImgLoader] = useState(false);
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
  } = useForm();

  const validateForm = (data) => {
    const newErrors = {};
    if (!data.fullname) newErrors.fullname = "Fullname is required";
    if (!data.mobile) {
      newErrors.mobile = "ContactNumber is required";
    } else if (data.mobile.length > 10) {
      newErrors.mobile = "ContactNumber is not valid";
    }
    if (!data.primaryemail) {
      newErrors.primaryemail = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(data.primaryemail)) {
      newErrors.primaryemail = "Email is not valid";
    }
    return newErrors;
  };

  useEffect(() => {
    const loadData = async () => {
      setLoader(true);
      const res = await getDatas();
      console.log('res::: ', res);

      const accountdata = res.data;

      setAccount(accountdata[0]);
      setLoader(false);
      setValue("primaryemail", accountdata[0]?.property?.primaryemail);
      setValue("fullname", accountdata[0]?.property?.fullname);
      setValue("mobile", accountdata[0]?.property?.mobile);
      setProfilepic(accountdata[0]?.profilepic);
    };
    loadData();

    return () => {
      setLoader(false);
    };
  }, []);


  const formsubmit = async (data) => {
    const validationErrors = validateForm(data);
    if (Object.keys(validationErrors).length > 0) {
      Object.entries(validationErrors).forEach(([key, message]) => {
        toast.error(message, { autoClose: 5000 });
      });
      return;
    }

    const postdata = await handlepostdata(data);
    if (postdata.status === 200) {
      toast.success(
        "Update Successfully",
        { autoClose: 5000 },
        { backgroundColor: "green" }
      );
    } else {
      toast.error("error", { autoClose: 5000 }, { backgroundColor: "red" });
    }
  };


  console.log('account::: ', account);

  const handlepostdata = async (value) => {
    const { property, onModel, _id } = account;

    const payload = {
      property: {
        ...property,
        mobile: value.mobile,
        primaryemail: value.primaryemail,
        fullname: value.fullname,
      },
    };

    const endpoint = onModel === "Member" ? `members/${_id}` : `prospects/${_id}`;
    const res = await patchAccDataService(endpoint, payload);

    return res;
  };


  const Imageuploaddata = async (value) => {
    showUploadImgLoader(true);
    let payload = {};
    payload.profilepic = value.secure_url;
    payload.property = account.property;
    payload.property.profilepic = [{
      attachment: value.secure_url,
      extension: value.original_extension,
      originalfilename: value.original_filename
    }];

    let res = '';
    if (account.onModel === "Member") {
      res = await patchMemberAccDataService(`/${account._id}`, payload);
    } else {
      res = await patchProspectAccDataService(`/${account._id}`, payload);
    }
    setProfilepic(value.secure_url);
    showUploadImgLoader(false);
    toast.success(
      "Image Uploaded Successfully",
      { autoClose: 5000 },
      { backgroundColor: "green" }
    );
    return res;
  }

  const handleImageChange = async (event) => {
    const newImage = event.target.files[0];
    const formData = new FormData();
    formData.append("file", newImage);
    formData.append("upload_preset", "egi2wepr");

    setLoader(true);

    try {
      const headers = {}; // You may add headers if required
      const response = await axios.post(
        'https://api.cloudinary.com/v1_1/membroz/upload',
        formData,
        { headers }
      );

      const res = response.data;
      await Imageuploaddata(res);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.log('Error uploading Image ', error);
    }
  };

  return (
    <>
      {!isLoading && (
        <section className="common-block pt-4 pb-3">
          <div className="container">
            <div className="row mb-5">
              <ToastContainer />
              <div className="col-md-10 col-lg-8 ml-auto mr-auto">
                <h3 className="card-title mb-4"> My Account </h3>
                <form
                  className="membroz-form membroz-form1"
                  onSubmit={handleSubmit(formsubmit)}
                >
                  <div className="row ">
                    <div className="col-lg-2 col-md-12">
                      <div className="img_tag_container">
                        <div className="form-group">
                          <div className="position-relative w-130">
                            <img
                              src={
                                profilepic ? profilepic : "/images/team1.jpg"
                              }
                              className="img-fluid rounded-circle profile-img"
                              alt=""
                            />

                            {/* <input type="file" onChange={UploadImage} /> */}

                            <label className="profile-img-edit">
                              <img
                                src="/images/edit-icon.svg"
                                alt=""
                                type="file"
                              />
                              <input
                                type="file"
                                id="uploadImg"
                                className="d-none"
                                onChange={(event) => {
                                  handleImageChange(event);
                                }}
                              />
                            </label>
                          </div>
                        </div>

                        {account?.membership && (
                          <div className="membership_place_bg badge ">
                            <p>
                              Membership name :{" "}
                              {account?.membership?.membershipname}{" "}
                            </p>
                            <p>
                              {" "}
                              Membership Start Date :{" "}
                              {moment(account?.membershipstart).format(
                                "DD/MM/YYYY"
                              )}
                            </p>
                            <p>
                              {" "}
                              Membership End Date :{" "}
                              {moment(account?.membershipend).format(
                                "DD/MM/YYYY"
                              )}
                            </p>
                            <p>
                              Membership Value :{" "}
                              {account?.membership?.property?.joiningfee}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                    {uploadImgLoader ? (
                      <>
                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6 mb-3">
                          <span className="btn-file text-center add-upload-inner-vcenter">
                            <img src="/Images/UploadImg.svg" alt="imgs" />
                          </span>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Full Name"
                          className="form-control mt-5 mb-3"
                          {...register("fullname")}
                        />
                        <span className="errorMessage">
                          {errors.fullname?.message}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Mobile"
                          className="form-control"
                          {...register("mobile")}
                        />
                        <span className="errorMessage">
                          {errors.mobile?.message}
                        </span>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          placeholder="Email"
                          className="form-control"
                          {...register("primaryemail")}
                        />
                        <span className="errorMessage">
                          {errors.primaryemail?.message}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mt-3 mb-4">
                      <div className="form-group">
                        <button
                          type="submit"
                          className="btn btn-primary btn-lg"
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}
